export default class Cache {
  constructor(api) {
    this.assets = {};
    this.api = void 0;
    this.api = api;
  }

  async getAsset(assetId) {
    const now = new Date().getTime();
    const record = this.assets[assetId];

    if (record && now - record.time < 5 * 60 * 1000) {
      return record.data;
    }

    const asset = await this.api.endpoints.getAsset(assetId);
    this.assets[assetId] = {
      data: asset,
      time: new Date().getTime()
    };
    return asset;
  }

}